import styles from './SharePostFooter.module.scss'
import {
  EmailIcon,
  EmailShareButton,
  FacebookIcon,
  FacebookShareButton,
  TwitterIcon,
  TwitterShareButton,
  ViberIcon,
  ViberShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'
import { Record, Static } from 'runtypes'
import { Post } from '../../../types'

const SharePostParameters = Record({
  post: Post,
})

type SharePostParameters = Static<typeof SharePostParameters>

const SharePostFooter = ({ post }: SharePostParameters) => {
  const getCurrentUrl = () =>
    typeof window !== 'undefined' ? window.location.href : null

  return (
    <div className={`${styles.SharePostFooter} px-5 sm:px-0`}>
      <div className={styles.SharePostTitle}>Podijelite vijest</div>
      <div className={styles.SocialIconsContainer}>
        <div className={styles.SocialIconButtons}>
          <FacebookShareButton
            url={getCurrentUrl()}
            quote={post.name}
            className={styles.SocialIconButton}
          >
            <FacebookIcon
              size={40}
              round={true}
              bgStyle={{ fill: `#1877F2` }}
            />
          </FacebookShareButton>
          <TwitterShareButton
            url={getCurrentUrl()}
            title={post.name}
            className={styles.SocialIconButton}
          >
            <TwitterIcon size={40} round={true} bgStyle={{ fill: `#1DA1F2` }} />
          </TwitterShareButton>
          <ViberShareButton
            url={getCurrentUrl()}
            className={styles.SocialIconButton}
          >
            <ViberIcon size={40} round={true} bgStyle={{ fill: `#793BAA` }} />
          </ViberShareButton>
          <WhatsappShareButton
            url={getCurrentUrl()}
            title={post.name}
            className={styles.SocialIconButton}
          >
            <WhatsappIcon
              size={40}
              round={true}
              bgStyle={{ fill: `#45C554` }}
            />
          </WhatsappShareButton>
          <EmailShareButton
            url={getCurrentUrl()}
            title={post.name}
            subject={post.name}
            body={post.name}
            className={styles.SocialIconButton}
          >
            <EmailIcon size={40} round={true} bgStyle={{ fill: `#DA0000` }} />
          </EmailShareButton>
        </div>
      </div>
    </div>
  )
}

export default SharePostFooter
